var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.QAsp_gzzb),
      expression: "QAsp_gzzb"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("OA审批-" + _vm._s(_vm.examine_name))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "overflow-x": "hidden"
    }
  }, [_c('el-row', {
    staticStyle: {
      "margin": "0px"
    }
  }, [_c('el-row', {}, [_c('el-table', {
    ref: "table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "border": true,
      "row-class-name": _vm.tableRowClassName,
      "data": _vm.tableData,
      "show-summary": "",
      "height": "650",
      "tooltip-effect": "dark",
      "expand-row-keys": _vm.expands
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "expand-change": _vm.handleSelect
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-table', {
          ref: "table",
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "header-cell-style": {
              background: '#edeff1',
              color: '#000000'
            },
            "border": true,
            "data": _vm.childTable,
            "height": "400",
            "tooltip-effect": "dark"
          },
          on: {
            "selection-change": _vm.handleSelectionChanges,
            "select": _vm.handleSelects
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "序号",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope_1) {
              return [_vm._v(_vm._s(scope_1.$index + 1))]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "organize_name",
            "align": "center",
            "label": "支援项目名"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "number_of_investors",
            "align": "center",
            "label": "开资人数"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payroll_payable",
            "align": "center",
            "label": "工资表应发工资"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "payroll_actual_salary",
            "align": "center",
            "label": "工资表实发工资"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "55"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "organize_name",
      "align": "center",
      "label": "项目名称",
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "收入"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "actual_estimate_name",
      "align": "center",
      "label": "是否开票",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "invoiced_amount",
      "align": "center",
      "label": "开发票金额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "开票明细",
      "width": "100"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "wage_quota",
      "align": "center",
      "label": "工资定额",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "contract_amount",
      "align": "center",
      "label": "合同金额",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quota_proportion",
      "align": "center",
      "label": "定额占比",
      "width": "100"
    }
  })], 1)], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "工资明细"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "invoicing_shift",
      "align": "center",
      "label": "开发票班次",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "quota_difference",
      "align": "center",
      "label": "定额差额",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "number_of_investors",
      "align": "center",
      "label": "开资人数",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_payable",
      "align": "center",
      "label": "工资表应发工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "personal_part_of_social_security",
      "align": "center",
      "label": "社保个人部分",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accumulation_fund_deduction",
      "align": "center",
      "label": "公积金扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "accident_insurance_deduction",
      "align": "center",
      "label": "意外保险扣款",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "clothing_deposit",
      "align": "center",
      "label": "服装押金",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payroll_actual_salary",
      "align": "center",
      "label": "工资表实发工资",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "temporary_expenses",
      "align": "center",
      "label": "临勤费用",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_expenses",
      "align": "center",
      "label": "总费用",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "actual_delivery_shift",
      "align": "center",
      "label": "实发班次",
      "width": "120"
    }
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "工资占比"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "proportion_wages",
      "align": "center",
      "label": "本月工资占比",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.proportion_wages) + "%")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "previous_month_one",
      "align": "center",
      "label": "上月工资占比",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.previous_month_one) + "%")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "备注",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.show),
            expression: "scope.row.show"
          }],
          staticStyle: {
            "margin-left": "-5px",
            "width": "150px"
          },
          attrs: {
            "size": "mini"
          },
          model: {
            value: (scope.row.remarks),
            callback: function($$v) {
              _vm.$set(scope.row, "remarks", $$v)
            },
            expression: "scope.row.remarks"
          }
        }), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!scope.row.show),
            expression: "!scope.row.show"
          }]
        }, [_vm._v(_vm._s(scope.row.remarks))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#01714d"
          },
          on: {
            "click": function($event) {
              return _vm.goMingXi(scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_reviewer_state == 0),
      expression: "is_reviewer_state == 0"
    }]
  }, [_c('el-col', {
    staticStyle: {
      "margin": "20px 40%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].save(_vm.id, 1)
      }
    }
  }, [_vm._v("同意")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "addbtn"
    },
    on: {
      "click": function($event) {
        return _vm.$refs['examine'].reject(_vm.id)
      }
    }
  }, [_vm._v("驳回")])], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-start",
      "flex-wrap": "wrap",
      "margin": "0 20px"
    }
  }, _vm._l((_vm.infor), function(item, index) {
    return _c('div', {
      staticStyle: {
        "flex": "1",
        "width": "calc((100% - 20px) / 6)",
        "min-width": "calc((100% - 20px) / 6)",
        "max-width": "calc((100% - 20px) / 6)"
      }
    }, [_c('div', {
      staticStyle: {
        "margin": "20px 0 0 0",
        "font-size": "18px"
      }
    }, [_vm._v(_vm._s(item.role_name) + " : " + _vm._s(item.staff_name))])])
  }), 0)], 1)], 1), _vm._v(" "), _c('examine', {
    ref: "examine",
    attrs: {
      "spare": _vm.spare,
      "id": _vm.id
    }
  }), _vm._v(" "), _c('gzmx', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gzmx),
      expression: "gzmx"
    }],
    ref: "gzmx",
    attrs: {
      "gzmxList": _vm.gzmxList,
      "zygzmxList": _vm.zygzmxList,
      "inforchilds": _vm.inforchilds,
      "organize_name": _vm.organize_name
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b38e384","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jcrsgl/QAsp/QAsp_gzzb.vue
// module id = null
// module chunks = 